import { TeliaAccordionItem, TeliaHeading, TeliaIcon, TeliaLink } from '@teliads/components/react';

import './BottomFaq.scss';
import { FAQSection } from 'pages/FlexibleSolutionsTemplate/models';
import { renderRichText } from 'utils/rich-text-render';

const BottomFaq = ({ title, items, cta }: FAQSection) => {
  return (
    <>
      <section className="bottom-faq">
        <TeliaHeading tag="h3" variant="title-300" className="bottom-faq__title">
          {title || ''}
        </TeliaHeading>
        <div className="bottom-faq__content">
          {items.map((content, id: number) => {
            return (
              <TeliaAccordionItem
                heading={content.title}
                key={id + content.title}
                dataTestid="faq-accordion-item"
              >
                {renderRichText(content.body.json)}
              </TeliaAccordionItem>
            );
          })}
        </div>
      </section>
      <>
        {cta && (
          <TeliaLink href={cta.url} variant="standalone">
            {cta.text}
            <TeliaIcon name="arrow-right" slot="right" size="sm" />
          </TeliaLink>
        )}
      </>
    </>
  );
};

export default BottomFaq;
